import Vue from 'vue';
import ViewUI from 'view-design';
import locale from 'view-design/dist/locale/es-ES';
import VueRouter from 'vue-router';
import Routers from './router';
import store from './store';
import Util from './libs/util';
import vClickOutside from 'v-click-outside'
import VueMq from 'vue-mq'
import App from './app.vue';
import 'view-design/dist/styles/iview.css';
import './tema-bdbn/index.less';
import * as VueGoogleMaps from 'vue2-google-maps'
//import imagen2 from "./images/banner2.jpg";
//import imagen3 from "./images/banner3.jpg";
//import imagen4 from "./images/banner4.jpg";

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDdFfnrFLy97FzX1l_n3UOLDF4JWVwXGZw',
    //libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,
     
    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
  })

Vue.use(VueRouter);
Vue.use(vClickOutside);
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1600,
    xxl: Infinity,
  },
  defaultBreakpoint: 'md' // customize this for SSR
})

Vue.use(ViewUI, {locale});

// 路由配置
const RouterConfig = {
    //mode: 'history',
    routes: Routers
};
const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    ViewUI.LoadingBar.start();
    Util.title(to.meta.title);
    next();
});

router.afterEach((to, from, next) => {
    ViewUI.LoadingBar.finish();
    window.scrollTo(0, 0);
});

new Vue({
    el: '#app',
    router: router,
    store: store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js